<template>
  <div
    v-for="(schedule, index) in shift.schedule"
    :key="index"
    class="card schedule-card mt-2"
    :style="getFlexboxOrderStyleFromTimeAndDate(schedule.startTime)"
  >
    <div class="card-body">
      <span class="time">
        {{ getScheduleTime(schedule) }}
      </span>
      <span class="badge rounded-pill border border-primary text-bg-light ms-1">
        {{ schedule.type }}
      </span>
      <span class="notes">
        {{ schedule.notes }}
      </span>
    </div>
  </div>
</template>

<script>
import {
  combineDateAndTime,
  parseTimeAsDateObject,
  formatTimeStringForHtmlInput,
  getFlexboxOrderStyleFromTime,
} from "../../../lib/date-functions";

export default {
  name: "RotaAgendaShiftActivities",
  props: {
    shift: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  setup: (props) => {
    const getFlexboxOrderStyleFromTimeAndDate = (time) => {
      return getFlexboxOrderStyleFromTime(
        combineDateAndTime(props.shift.startDate, parseTimeAsDateObject(time)),
      );
    };

    const getScheduleTime = (schedule) => {
      return `${formatTimeStringForHtmlInput(
        schedule.startTime,
      )} - ${formatTimeStringForHtmlInput(schedule.endTime)}`;
    };
    return {
      getFlexboxOrderStyleFromTimeAndDate,
      getScheduleTime,
    };
  },
};
</script>

<style scoped>
.card {
  --bs-card-spacer-x: 0.5em;
  --bs-card-spacer-y: 0.5em;
  overflow-x: hidden;
}
</style>
